import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import React from 'react';
import classNames from 'classnames';
import Checkbox from '../../../../../../components/Checkbox';
import { putUserAttribute } from '../../../../../../api/put-user-attribute';
export var IntegratedExperience = function IntegratedExperience(_ref) {
  var environment = _ref.environment,
      hasIntegratedExperience = _ref.hasIntegratedExperience,
      _ref$onReloadHandler = _ref.onReloadHandler,
      onReloadHandler = _ref$onReloadHandler === void 0 ? function () {
    return window.location.reload();
  } : _ref$onReloadHandler,
      currentProduct = _ref.currentProduct,
      onShowFeedbackModal = _ref.onShowFeedbackModal;
  var isCurrent = currentProduct === 'adminpanel';
  return /*#__PURE__*/React.createElement("div", {
    className: "app-switcher-product",
    "data-qa": "app-switcher-integrated-experience"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('integrated-experience-wrapper', {
      'is-active': isCurrent
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: classNames('product-title', {
      'product-current': isCurrent
    })
  }, "APM Integrated Experience"), /*#__PURE__*/React.createElement("div", {
    className: "product-description"
  }, "Infrastructure, APM monitoring and logs.", ' ', /*#__PURE__*/React.createElement("a", {
    className: "learn-more",
    href: "https://documentation.solarwinds.com/en/Success_Center/apm/Content/APM_Documentation.htm"
  }, "Learn more"))), /*#__PURE__*/React.createElement("div", {
    className: "toggle"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    toggle: true,
    defaultChecked: hasIntegratedExperience,
    onClick: handleOnClick
  }))));

  function handleOnClick() {
    return _handleOnClick.apply(this, arguments);
  }

  function _handleOnClick() {
    _handleOnClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (hasIntegratedExperience && typeof onShowFeedbackModal === 'function') {
                onShowFeedbackModal(toggleAttribute);
              } else {
                toggleAttribute();
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleOnClick.apply(this, arguments);
  }

  function toggleAttribute() {
    return _toggleAttribute.apply(this, arguments);
  }

  function _toggleAttribute() {
    _toggleAttribute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return putUserAttribute(environment, 'combined_nav', !hasIntegratedExperience);

            case 3:
              onReloadHandler();
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              // eslint-disable-next-line no-console
              console.error(_context2.t0);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));
    return _toggleAttribute.apply(this, arguments);
  }
};